import { withJsonFormsControlProps } from "@jsonforms/react";
import { Box, FormHelperText } from "@mui/material";
import { CustomRendererProps } from "../types";
import { SchemaData } from "layouts/aplicacoes/Events/hooks/types";
import { GenerateFinancialButton } from "layouts/aplicacoes/Events/components/GenerateFinancialButton";

function EventFinancialAction({
  data,
  enabled,
  handleChange,
  errors,
}: CustomRendererProps<SchemaData>) {
  if (!data?.id) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%", mt: 2, mb: 1 }}>
      <GenerateFinancialButton
        queryParam={Number(data.id)}
        data={data}
        onGenerated={(generated) => {
          handleChange("saleEnabled", true as any);
          handleChange(
            "registration",
            Number(data.ticketPrice || 0).toLocaleString("pt-BR", {
              currency: "BRL",
              style: "currency",
            }) as any
          );
          handleChange("eCommerceProductId", generated.eCommerceProductId as any);
          handleChange("eCommerceControlSKUId", generated.eCommerceControlSKUId as any);
          handleChange("eCommerceSkuId", generated.eCommerceSkuId as any);
          if (generated.financialPriceSyncUntil) {
            handleChange("status", "DRAFT" as any);
            handleChange("financialPriceSyncUntil", generated.financialPriceSyncUntil as any);
          }
        }}
        onSyncFinished={() => {
          handleChange("status", "ACTIVE" as any);
          handleChange("financialPriceSyncUntil", undefined as any);
        }}
      />
      {!enabled && <FormHelperText error>{errors}</FormHelperText>}
    </Box>
  );
}

export default withJsonFormsControlProps(EventFinancialAction);
